import { FC, useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import { useAppSelector } from '../../hooks/redux';

import { selectUser } from '../../store/auth.slice';
import { IConsultation } from '../../store/types';
import { useLazyGetConsultationsQuery } from '../../services/users.api';

import { ClientEnd } from './client';
import { PsychologEnd } from './psycholog';


export const EndMeet: FC = () => {
  const [isPsychologist, setIsPsychologist] = useState(false);
  const [consultation, setConsultation] = useState<IConsultation | null>(null);
  const [getConsultations, { data: consultations }] = useLazyGetConsultationsQuery();
  const userData = useAppSelector(selectUser);
  const params = useParams();
  const roomName = params.id;

  useEffect(() => {
    getConsultations({ code: String(roomName) });
  }, []);

  useEffect(() => {
    if (consultations) {
      setConsultation(consultations[0]);
    }
  }, [consultations]);

  useEffect(() => {
    if (!userData || !consultation) return;
    if (userData.id === consultation.psychologist.id) {
      setIsPsychologist(true);
    }
  }, [userData, consultation]);
  return <>{isPsychologist ? <PsychologEnd consultation={consultation} /> : <ClientEnd />}</>;
};
